import { render } from "./InactiveLandingPage.vue?vue&type=template&id=2c6e7f60&scoped=true"
import script from "./InactiveLandingPage.vue?vue&type=script&lang=ts"
export * from "./InactiveLandingPage.vue?vue&type=script&lang=ts"

import "./InactiveLandingPage.vue?vue&type=style&index=0&id=2c6e7f60&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c6e7f60"

export default script